import React from "react";
import { HOME } from "@/constants/testIds";

export default function Steps({ steps = [], onBook }) {
  return (
    <section className="py-16 md:py-24">
      <div className="mx-auto max-w-[1200px] px-5 md:px-10">
        <div className="max-w-2xl">
          <div className="eyebrow">Easy to get started</div>
          <h2 className="font-serif-ev mt-4 text-4xl sm:text-5xl md:text-6xl leading-[1.02] tracking-tight">
            Three gentle steps to begin.
          </h2>
        </div>

        <ol className="mt-10 md:mt-14 space-y-8 md:space-y-10 max-w-3xl">
          {steps.map((s) => (
            <li key={s.n} className="grid grid-cols-[auto_1fr] gap-6 md:gap-10">
              <div className="font-serif-ev text-4xl md:text-5xl" style={{ color: "var(--ev-blue)" }}>{s.n}</div>
              <div>
                <h3 className="font-serif-ev text-2xl md:text-3xl leading-tight">{s.title}</h3>
                <p className="mt-2 text-[15px] md:text-base max-w-xl" style={{ color: "var(--ev-muted)" }}>
                  {s.description}
                </p>
              </div>
            </li>
          ))}
        </ol>

        <div className="mt-12 flex flex-col items-start gap-2">
          <button data-testid={HOME.stepsBookBtn} onClick={onBook} className="ev-btn ev-btn-primary">
            Book a free session
          </button>
          <div className="text-sm" style={{ color: "var(--ev-muted)" }}>No credit card required</div>
        </div>
      </div>
    </section>
  );
}
